export default __webpack_public_path__ + "static/draugepopup_bex-1c9552e9b9a3cdbb6f2dfc5acc8bfbc1.png";